import { usePublicFeatureFlags } from '@/shared/api/featureFlagsQueries'

export function usePartnerOfferFeatureFlag(): { enabled: boolean; isLoading: boolean } {
  const flagsQuery = usePublicFeatureFlags()
  return {
    enabled: flagsQuery.data?.find((row) => row.module_name === 'partner-offer')?.enabled === true,
    isLoading: flagsQuery.isPending,
  }
}

export function usePartnerOfferEnabled(): boolean {
  return usePartnerOfferFeatureFlag().enabled
}
